export default "__VITE_ASSET__jwX6Nq4D__"